import { useMemo, useState } from 'react';
import SessionsPitchChart from 'pages/Sessions/charts/SessionsPitchChart';
import { TargetShapeGeo } from 'types/models/SessionEnrichment';
import { MeasurementDetailDto, SessionDetailsResponseDto } from 'types/models/MeasurementDetail';
import { detailToMarker } from './topViewMarkers';

const NO_SESSIONS: never[] = [];
const noop = (): void => undefined;

interface SessionTopViewProps {
  details: SessionDetailsResponseDto;
  /** The focused player's kicks. */
  kicks: MeasurementDetailDto[];
  currentId: string;
  onSelectKick: (kickId: string) => void;
  /** Session targets (from the SharedCalculator enrichment) drawn on the pitch; the aimed-at one stands out. */
  targets?: TargetShapeGeo[];
}

/**
 * Pitch top view for goalkeeper / throw-in / corner sessions. Same chart, container and mode as the player aggregate
 * views (`KickLocationsCard`): every kick of the focused player plotted at its kick origin, reachable regions for
 * corner / throw-in, and the selected kick highlighted with its trajectory. Tap a kick to switch to it.
 */
const SessionTopView: React.FunctionComponent<SessionTopViewProps> = ({ details, kicks, currentId, onSelectKick, targets }) => {
  const markers = useMemo(() => kicks.map((k) => detailToMarker(k, details)), [kicks, details]);
  const selectedIds = useMemo(() => new Set([currentId]), [currentId]);
  const [hoveredId, setHoveredId] = useState<string | null>(null);

  return (
    <div className='sessions-kick-locations-view sessions-kick-locations-view--top sessions-kick-locations-view--landscape'>
      <SessionsPitchChart
        data={markers}
        sessions={NO_SESSIONS}
        selectedIds={selectedIds}
        hoveredId={hoveredId}
        onPointClick={(id) => { if (id !== currentId) onSelectKick(id); }}
        onPointHover={(id) => setHoveredId(id)}
        onDragSelected={noop}
        mode='origin'
        dragSelectionEnabled={false}
        landscape
        targets={targets}
      />
    </div>
  );
};

export default SessionTopView;
